/**
 * Created by Hardy on 2018/1/23.
 */
export  default {
  docHead : (state,getters) =>{
    if(state.docInfo.face){
      return `${state.docInfo.face}?${Date.parse(new Date())}`;
    }else{
      return '';
    }
  },
  docAcc : state =>{
    return state.docInfo.account;
  }
}



// WEBPACK FOOTER //
// ./src/vuex/rootGetters.js